import { render } from "./Home.vue?vue&type=template&id=43613565"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=43613565&lang=css"

import exportComponent from "/Users/david.gutierrez/Projects/holanda_dataviz_2024/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__